import axios from 'axios';
import router from '../router';
import { removeCookie as removeUserCookie } from '../composables/useAuth';

// 401が返ってきたらすぐにログアウトさせる設定
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      removeUserCookie();

      router.push('/login');

      return Promise.reject(error);
    } else if (error.response.status === 403) {
      router.push('/');

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default async function callApi(reqOptions) {
  let data, error;
  try {
    // LaravelのCSRF対策のためにGET以外のリクエストでは一度/sanctum/csrf-cookieへGETリクエストを送る必要がある
    if (reqOptions.method?.toLowerCase() !== 'get') {
      await axios('/sanctum/csrf-cookie');
    }

    const response = await axios(reqOptions);
    data = response.data;
  } catch (e) {
    if (e.response) {
      error = {
        status: e.response.status,
        message: e.response.data.message ? e.response.data.message : 'エラーが発生しました。',
      };
    } else if (e.request) {
      console.log('Request Error: ', e);
      error = {
        status: '',
        message: e.request,
      };
    } else {
      console.log('Unknown Error: ', e);
      error = {
        status: '',
        message: e.message,
      };
    }
  }

  return { data, error };
}
